// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".column-textarea[data-v-50316d51] {\n  min-width: 250px;\n}\n.cp-col-selected[data-v-50316d51] {\n  background-color: #f4fbf4;\n}\n.catindex[data-v-50316d51] {\n  width: 90px;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
